/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waitlist_PromoteInputs */



/**
* | output |
* | --- |
* | "Promote" |
*
* @param {Waitlist_PromoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const waitlist_promote = /** @type {((inputs?: Waitlist_PromoteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waitlist_PromoteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accepter")
	if (locale === "es") return /** @type {LocalizedString} */ ("Admitir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Admitir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ammetti")
	return /** @type {LocalizedString} */ ("Promote")
});